<template>
	<div>
		<!-- Core entity card if there is a holder -->
		<div v-if="holderId">
			<core-entity-card
				:entity="holder"
				:hasActions="true"
				:pinnable="false"
				:isExpanded="false"
				@updated="refetchCase"
				@added="refetchCase"
				@deleted="refetchCase"
			>
				<!-- Header -->
				<div class="fs4 c1 pt3 pb3" slot="header">{{ $t("holder") }}</div>

				<!-- Footer -->
				<div class="flex xs-12 xs-right mt6" slot="footer">
					<!-- TODO: make it work -->
					<j-button type="error" @click="removeHolder()" size="small">
						<crm-icon name="delete" color="c5" class="mr2" />Remove
					</j-button>
				</div>
			</core-entity-card>
		</div>

		<!-- Select holder if there is not any -->
		<j-card class="bg5 p4" v-else>
			<!-- Header -->
			<div class="fs4 fw7 c1 pt2">{{ $t("holder") }}</div>
			<!-- Select a holder -->
			<div class="flex c6 pt6 pb4">There is no holder for this case</div>
			<j-button
				size="small"
				class="mt2"
				@click="$modal.show('addHolder')"
				type="primary"
				>Add Holder</j-button
			>
		</j-card>

		<!-- Modal -->
		<core-modal
			name="addHolder"
			headline="Select Entity"
			:pivotX="0"
			:pivotY="0"
			:hasHeader="false"
		>
			<div style="height:100vh; overflow: scroll;">
				<entity-picker
					@entity:selected="addHolder($event)"
					:allowedEntityTypes="allowedEntityTypes"
				/>
			</div>
		</core-modal>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import JCard from "@/components/JCard"
import CrmIcon from "@/components/CrmIcon"
import CoreEntityCard from "@/modules/core/components/CoreEntityCard"
import EntityPicker from "../CaseForm/EntityPicker/EntityPicker"
import CoreModal from "@/modules/core/components/CoreModal"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		JButton,
		EntityPicker,
		JCard,
		CrmIcon,
		CoreEntityCard,
		CoreModal
	},

	data() {
		return {
			allowedEntityTypes: ["individual", "company"]
		}
	},

	computed: {
		holder() {
			const result = JSON.parse(
				JSON.stringify(this.$store.state.caseManagement?.case?.holder || {})
			)
			return result
		},

		holderId() {
			return this.$store.state.caseManagement?.case?.holder?.id
		}
	},

	methods: {
		refetchCase() {
			this.$store.dispatch("caseManagement/fetchCase", {
				caseId: this.$store.state.caseManagement.caseId
			})
		},

		async addHolder(payload) {
			const query = gql`
				mutation updateCase($id: String!, $input: updateCaseInput!) {
					updateCase(id: $id, input: $input) {
						status
						errors
					}
				}
			`

			const variables = {
				id: this.$store.state.caseManagement.caseId,
				input: {
					holderId: payload.id
				}
			}

			const res = await api({ query, variables })

			if (res?.data?.updateCase?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.updateCase?.errors ||
							res?.data?.updateCase?.errors_2.message ||
							"Oops ! An error occured."
					}
				})
			} else {
				this.$modal.hide("addHolder")
			}

			this.refetchCase()
		},

		async removeHolder() {
			const query = gql`
				mutation updateCase($id: String!, $input: updateCaseInput!) {
					updateCase(id: $id, input: $input) {
						status
						errors
					}
				}
			`

			const variables = {
				id: this.$store.state.caseManagement.caseId,
				input: {
					holderId: ""
				}
			}

			const res = await api({ query, variables })

			if (res?.data?.updateCase?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.updateCase?.errors ||
							res?.data?.updateCase?.errors_2.message ||
							"Oops ! An error occured."
					}
				})
			}

			this.refetchCase()
		}
	}
}
</script>
